import { Badge } from "@/components/ui/badge";

const MAP = {
  OK: { label: "OK", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  ABONO: { label: "ABONO", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  INCIDENCIA: { label: "INCIDENCIA", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  POSIBLE_DUPLICADO: { label: "POSIBLE DUPLICADO", cls: "bg-amber-50 text-amber-700 border-amber-200" },
};

const GMAIL = {
  Procesada: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Incidencia: "bg-rose-50 text-rose-700 border-rose-200",
  "No-Factura": "bg-slate-100 text-slate-600 border-slate-200",
  "Revisión-Manual": "bg-amber-50 text-amber-700 border-amber-200",
};

export function EstadoBadge({ estado }) {
  const m = MAP[estado] || { label: estado, cls: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <Badge
      data-testid={`estado-badge-${estado}`}
      variant="outline"
      className={`${m.cls} rounded-full font-semibold text-[10px] tracking-wide px-2.5 py-0.5`}
    >
      {m.label}
    </Badge>
  );
}

export function GmailLabel({ label }) {
  const cls = GMAIL[label] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <Badge
      data-testid={`gmail-label-${label}`}
      variant="outline"
      className={`${cls} rounded-full font-medium text-[10px] px-2 py-0.5`}
    >
      {label}
    </Badge>
  );
}
